import { useEffect, useState } from "react";
import { printerApi } from "../api/resources.js";

type PrintJob = Awaited<ReturnType<typeof printerApi.printJobs>>["printJobs"][number];

export function PrintJobHistory() {
  const [printJobs, setPrintJobs] = useState<PrintJob[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    printerApi
      .printJobs()
      .then((res) => setPrintJobs(res.printJobs))
      .catch((err: unknown) => setError(err instanceof Error ? err.message : "取得に失敗しました"));
  }, []);

  return (
    <div className="stack">
      <h2>印刷ジョブ履歴</h2>
      {error && <div className="alert alert-error">{error}</div>}
      <div className="card">
        <table>
          <thead>
            <tr>
              <th>日時</th>
              <th>伝票番号</th>
              <th>方式</th>
              <th>種別</th>
              <th>状態</th>
              <th>メッセージ</th>
              <th>プレビュー</th>
            </tr>
          </thead>
          <tbody>
            {printJobs.map((job) => (
              <tr key={job.id}>
                <td>{new Date(job.createdAt).toLocaleString("ja-JP")}</td>
                <td>{job.receiptNumber}</td>
                <td>{job.provider}</td>
                <td>{job.isReprint ? "再印刷" : "通常"}</td>
                <td>
                  {job.status === "SUCCESS" ? <span className="badge">成功</span> : <span className="badge badge-danger">失敗</span>}
                </td>
                <td>{job.errorMessage ?? ""}</td>
                <td>
                  {job.previewUrl && (
                    <a href={job.previewUrl} target="_blank" rel="noreferrer">
                      表示
                    </a>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {printJobs.length === 0 && <div className="empty-state">印刷ジョブがありません</div>}
      </div>
    </div>
  );
}
